/* import __COLOCATED_TEMPLATE__ from './part-text.hbs'; */
import Component from '@glimmer/component';
import { numberToUserDisplay } from '@ebiz/pretty-num';

interface PartTextCircuitAnnotationArgs {
  item: PartItem;
  stageLetter: string;
  unit: string;
  direction: string;
  matrix: string;
}

type PartItem = {
  name: string;
  value: number;
  tolerance: string;
};

export default class PartTextCircuitAnnotation extends Component<PartTextCircuitAnnotationArgs> {
  get yPos(): number {
    let value = 13.2;
    if (!this.args.item.name || !this.args.item.tolerance) {
      switch (this.args.direction) {
        case 'up':
          value = 0;
          break;
        case 'down':
          value = 26.4;
          break;
      }
    }
    return value;
  }
  get name(): string {
    return this.args.item.name && this.args.item.tolerance
      ? this.args.item.name.toUpperCase() + (this.args.stageLetter ? this.args.stageLetter : '')
      : '';
  }
  get tolerance(): string {
    return this.args.item.tolerance ? this.args.item.tolerance : '';
  }
  get value(): string {
    let adjusted = '';
    if (this.args.item.value) {
      adjusted = numberToUserDisplay(this.args.item.value, 'Engineering', 3, { showZeroes: false }) + this.args.unit;
      adjusted = adjusted.indexOf('Inf') > -1 ? '' : adjusted;
    }
    return adjusted;
  }
  get anchor(): string {
    return this.args.unit === 'V' ? 'middle-anchor' : '';
  }
}
